"use client";

import { Typography } from "@/components/ui/typography";
import type { UseCaseFAQProps } from "./types";
import { memo } from "react";
import { cn } from "@/lib/utils";
import {
    FaqStackWithContentful,
  FaqLinkBlock,
} from "@/components/screen/global-components/faq";

const ServicesFAQ = ({ content, className }: UseCaseFAQProps) => {

  return (
    <section className={cn("section", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="border-b border-gray-300">
          <Typography
            variant="heading4"
            className="text-semantic-text-primary md:text-gray-800"
            asChild
          >
            <h2>Frequently asked questions</h2>
          </Typography>
          <FaqStackWithContentful content={content} className="mt-6" />
        </div>
        <FaqLinkBlock
          title="Have more questions? Visit our FAQ page for more answers."
          className="mt-6 py-4 sm:p-0"
        />
      </div>
    </section>
  );
};

export default memo(ServicesFAQ);
